// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_F6B","cls2":"JJHomePageSearch-cls2_Rvo JJHomePageSearch-cls1_F6B"};